import { createSlice } from '@reduxjs/toolkit';

interface MembershipProgramsState {
  selectedPet: {
    id: number;
    name: string;
    image: string;
    protocolNumber: number;
    petTypeCode: string;
    petTypeId: number;
  } | null;
  selectedSubscriptionGroup: PatientSubscriptionGroup | null;
  selectedHealthExpenditure: {
    subscriptionName: string;
    subscriptionId: number;
    patientSubscriptionNumber: number;
    code: string;
  } | null;
  selectedSubscriptionGroupId: number | null;
  selectedPetId: number | null;
}

const initialState: MembershipProgramsState = {
  selectedPet: null,
  selectedSubscriptionGroup: null,
  selectedHealthExpenditure: null,
  selectedSubscriptionGroupId: null, // baska sayfadan yonlendirme yapilirken kullanilir
  selectedPetId: null, // baska sayfadan yonlendirme yapilirken kullanilir
};

export const membershipProgramsSlice = createSlice({
  name: 'membershipPrograms',
  initialState,
  reducers: {
    setSelectedPet: (state, action) => {
      state.selectedPet = action.payload;
    },
    setSelectedSubscriptionGroup: (state, action) => {
      state.selectedSubscriptionGroup = action.payload;
    },
    setSelectedHealthExpenditure: (state, action) => {
      state.selectedHealthExpenditure = action.payload;
    },
    setSelectedSubscriptionGroupId: (state, action) => {
      state.selectedSubscriptionGroupId = action.payload;
    },
    setSelectedPetId: (state, action) => {
      state.selectedPetId = action.payload;
    },

    reset: (state) => {
      state.selectedPet = null;
      state.selectedSubscriptionGroup = null;
      state.selectedHealthExpenditure = null;
      state.selectedSubscriptionGroupId = null;
      state.selectedPetId = null;
    },
  },
});

export const {
  reset,
  setSelectedPet,
  setSelectedSubscriptionGroup,
  setSelectedHealthExpenditure,
  setSelectedSubscriptionGroupId,
  setSelectedPetId,
} = membershipProgramsSlice.actions;

export default membershipProgramsSlice;

